'use client';

import { LoadingScreen } from "components/loading-screen";
import useApi from "hooks/useApi";
import { useRouter } from "next/navigation";
import { createContext, useEffect, useMemo, useState } from "react";
import { APPOINTMENT } from "utils/constant";

const AppointmentContext = createContext();

function AppointmentProvider({ children, params }) {
    const router = useRouter();
    const { apiCalling } = useApi();
    const [loading, setLoading] = useState(true);

    const companyId = params?.companyid;

    const [companyInformation, setCompanyInformation] = useState(null);
    const [appointmentSuccess, setAppointmentSuccess] = useState(false);

    const controller = new AbortController();
    const { signal } = controller;

    async function getCompanyInformation() {
        try {
            setLoading(true);
            const params = { company_id: decodeURIComponent(companyId) };
            const response = await apiCalling({ url: APPOINTMENT.get, params, signal });
            setCompanyInformation(response.data.result);
        } catch (error) {
            console.log('ERROR CODE', error)
            controller.abort();
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!companyId) return (router.push('@/app/not-found'));
        getCompanyInformation();
    }, [companyId]);


    async function CreateAppointment(data) {
        try {
            const values = { company_id: decodeURIComponent(companyId), ...data };
            await apiCalling({ url: APPOINTMENT.create, data: values, method: 'post', });
            setAppointmentSuccess(true);
        } catch (error) {
            console.error(error);
            throw error
        }
    }

    const memoizedValue = useMemo(
        () => ({
            loading,
            companyInformation,
            CreateAppointment,
            companyId,
            appointmentSuccess
        }),
        [companyInformation, appointmentSuccess, loading]
    );
    return <AppointmentContext.Provider value={memoizedValue}>{loading ? <LoadingScreen /> : children}</AppointmentContext.Provider>;
}

export { AppointmentContext, AppointmentProvider };
